module.exports = __webpack_public_path__ + "static/media/slideshow-22.e209dfe8.jpeg";